import { AIMS, PROMPT_SEARCH } from '@disco/constants/FeatureTypes'
import { isFeatureEnabled } from '@disco/state-management/selectors/business'

import { useSelector } from 'hooks/use-redux'

// Checks if prompt (LLM) search is available via AIMS or the DISCO Prompt
// Search plan feature.
export const usePromptSearchEnabled = (): boolean => {
  const aimsEnabled = useSelector(state =>
    isFeatureEnabled(state, { featureName: AIMS }),
  )
  const promptSearchEnabled = useSelector(state =>
    isFeatureEnabled(state, { featureName: PROMPT_SEARCH }),
  )
  return aimsEnabled || promptSearchEnabled
}
